import React, { useContext } from 'react';
import BackButton from '../BackButton';
import {
  ACTIVE_VIEW,
  AutomationsContex
} from '../engine/FormBuilderAutomationsEngine';
import { Container } from './FormBuilderStatusesView';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components/macro';
import { SimpleFlexContainer } from '../layouts/ng-layouts/Containers';
import useTranslations from '../../hooks/useTranslations';
import Button from '../Button';
import FormBuilderBulkActionCardEngine from '../engine/FormBuilderBulkActionCardEngine';

const TitleContainer = styled.div`
  display: flex;
`;

const EmptyState = styled.div`
  font-style: italic;
  margin-left: 51px;
`;

const H2 = styled.h2`
  margin-bottom: 0.5rem;
`;

const LeftSidePositioner = styled.div`
  align-self: center;
`;
const NewBtnPositioner = styled.div`
  margin-left: auto;
  align-self: center;
`;

const Subtitle = styled.div`
  color: #8c93a6;
  font-size: 14px;
  line-height: 20px;
`;

const AddBulkActionButton = styled(Button)`
  height: 40px;
`;

const EmptyStateLine = styled.div`
  background: #1118270d;
  margin: 1rem 0 1rem 51px;
  width: calc(100% - 51px);
  height: 1px;
`;

const BulkActionTableHeaders = styled.div`
  color: #383838;
  display: flex;
  font-weight: 700;
  line-height: 20px;
  margin: 1rem 20px 1rem 51px;
`;

const BulkActionTableHeader = styled.div`
  flex: 1;
`;

const FormBuilderBulkActionsView = props => {
  const { setActiveView } = useContext(AutomationsContex);
  const t = useTranslations();
  return (
    <>
      <Container>
        <SimpleFlexContainer>
          <TitleContainer>
            <BackButton
              onClick={() => setActiveView(ACTIVE_VIEW.AUTOMATIONS_LIST)}
            />
            <LeftSidePositioner>
              <H2>{t('bulkActions.list.title')} </H2>
              <Subtitle>{t('bulkActions.list.subtitle')}</Subtitle>
            </LeftSidePositioner>
            <NewBtnPositioner>
              <AddBulkActionButton
                onClick={() => props.clickedAddBulkAction()}
                disabled={props.disableAddButton}
              >
                {t('bulkActions.list.add')}
              </AddBulkActionButton>
            </NewBtnPositioner>
          </TitleContainer>

          <BulkActionTableHeaders>
            <BulkActionTableHeader>Button label</BulkActionTableHeader>
            <BulkActionTableHeader>Displays for</BulkActionTableHeader>
            <BulkActionTableHeader>Action</BulkActionTableHeader>
          </BulkActionTableHeaders>

          {props.list && !!props.list.length ? (
            <DragDropContext onDragEnd={props.onDragEnd}>
              <Droppable droppableId="droppable">
                {provided => (
                  <>
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      {props.list.map(ba => (
                        <FormBuilderBulkActionCardEngine
                          key={ba.id}
                          bulkActionData={ba}
                          customStatusLabels={props.customStatusLabels}
                          id={ba.id}
                          label={ba.label}
                          position={ba.position}
                          statuses={ba.statuses}
                          updateValue={ba.updateValue}
                          onEdit={() => props.clickedEditBulkAction(ba)}
                          onDelete={() => props.onBulkActionDelete(ba.id)}
                          update={(payload, showSnackbar) => {
                            if (showSnackbar) {
                              props.showSnackbarOnSave.current = true;
                            }
                            props.dispatch({
                              type: 'update_single_bulk_action',
                              payload,
                              id: ba.id
                            });
                          }}
                        />
                      ))}
                    </div>
                  </>
                )}
              </Droppable>
            </DragDropContext>
          ) : (
            <>
              <EmptyStateLine />
              <EmptyState>{t(`bulkActions.empty`)}</EmptyState>
            </>
          )}
        </SimpleFlexContainer>
      </Container>
    </>
  );
};

export default FormBuilderBulkActionsView;
